module.exports = __webpack_public_path__ + "media/svgs/Tanzfabrik_Signet-white-3ab0131b6fb4145ab582665a0f2ab3ce.svg";